import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import "./App.css";
import { AppProviders } from "AppProviders";
import { StyledEngineProvider } from "@mui/material";

// Disable console.log and console.warn in production
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.warn = () => {};
}

const root = ReactDOM.createRoot(document.getElementById("root"));
const isDev = process.env.NODE_ENV === 'development';
root.render(
  isDev ? (
    <StyledEngineProvider>
      <React.StrictMode>
        <AppProviders>
          <App />
        </AppProviders>
      </React.StrictMode>
    </StyledEngineProvider>
  ) : (
    <StyledEngineProvider>
      <AppProviders>
        <App />
      </AppProviders>
    </StyledEngineProvider>
  ) 
);
